import { gql } from '@apollo/client';

export const GET_MITARBEITER_PERSONAL_IDS = gql`
  query mitarbeiter_getMitarbeiterPersonalIds($standortId: String!) {
    Anlageassistent_getMitarbeiterPersonalIds(standortId: $standortId) {
      e2nIdMitarbeiter {
        e2nId
      }
      personalnummernMitarbeiter {
        personalnummer
      }
    }
  }
`;
